import { Component, OnInit, OnDestroy } from '@angular/core';
import { ShopService } from 'src/app/shared/api/shop.service';
import { Collection } from 'src/app/shared/interfaces/custom/collection';

@Component({
  selector: 'app-restaurant-banner',
  templateUrl: './restaurant-banner.component.html',
  styleUrls: ['./restaurant-banner.component.scss'],
})
export class RestaurantBannerComponent implements OnInit {
  articoli: any[] = [];

  collectionName: string = '';
  bgColor: string = '';
  accentColor: string = '';

  // Opzioni per ngx-owl-carousel-o
  customOptions = {
    loop: true,
    margin: 24,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
  };

  constructor(private shopService: ShopService) {}

  ngOnInit(): void {
    // NOTA: endpoint "Collections" eliminato dal backoffice (risponde 404). Codice commentato il 2026-07-29,
    // lasciato per riferimento futuro nel caso torni disponibile un nuovo endpoint equivalente.
    // this.shopService.getCollections().subscribe((collections: Collection[]) => {
    //   if (collections && collections.length > 0) {
    //     const firstCollection = collections[0];
    //     this.collectionName = firstCollection.descrizione;
    //     this.bgColor = firstCollection.color1 || this.bgColor;
    //     this.accentColor = firstCollection.color2 || this.accentColor;

    //     this.shopService.getArticoliOfCollection(firstCollection.id).subscribe((response: any) => {
    //       this.articoli = Array.isArray(response) ? response : response.body || [];
    //     });
    //   }
    // });
  }
}
